import * as types from '../constants/chartConstants';
import appConstants from '../appConstants';
import moment from 'moment';
import i18next from 'i18next';
const initialState = {
  localstorageUpdated: 0,
  flag:0,
  message:'loading'
};

const updateChartValue = (chartValue, timeUnit) => {
  const data = [];
  const arr = chartValue;
  if (chartValue) {
    arr.map(item => {
      const obj = {};
      obj.Price = item.price;
      const timeXAxis = new Date(item.key * timeUnit * 1000); // given date convert to UTC
      obj.Time = timeXAxis.toLocaleTimeString(); // UTC convert to local time
      data.push(obj);
    });
  }
  return data;
};

const formatDateTradeDate = (dataArray) => {
  dataArray.slice().forEach((data, index, object) => {
    data.date = new Date(data.TradeDate);
     let day = new Date(data.TradeDate).getUTCDate();
    let year = new Date(data.TradeDate).getUTCFullYear();
    let month = new Date(data.TradeDate).getUTCMonth();
   data.date = new Date(year, month, day, 0, 0, 0, 0);
    // if ( Object.prototype.toString.call(data.date) === "[object Date]" ) {
    //   // it is a date
    //   if ( isNaN( data.date.getTime() ) ) {
    //     // invalid date
    //     dataArray.splice(object.length - 1 - index, 1);
    //   }
    // }
    if (data.OA === null) {
      data.open = 0;
    }
    else{
      data.open = data.OA;
    }
    if (data.HA === null) {
      data.high = 0;
    }
    else {
      data.high=data.HA;
    }
    if (data.LA === null) {
      data.low = 0;
    }
    else {
      data.low=data.LA;
    }
    if (data.CA === null) {
      data.close = 0;
    }
    else {
      data.close=data.CA;
    }
  });
  return dataArray;
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOAD_CHART:
      return {
        ...state,
      };
    case types.LOAD_CHART_SUCCESS:
      return {
        ...state,
        chartValue: updateChartValue(action.result.data, action.timeUnit)
      };
    case types.LOAD_CHART_FAILURE:
      return {
        ...state,
      };
    case types.LINE_CHART:
      return {
        ...state,
      };
    case types.LINE_CHART_SUCCESS:
  //  console.log(" LINE_CHART_SUCCESS "+JSON.stringify(action));
      if ( action.result.dataObject.length > 0) {
      //  console.log(" inside if ");
        let lineChartValue = action.result.dataObject;
        return {
          ...state,
          flag:0,
          lineChartValue: lineChartValue,
          isChartDataNull: false,
          respQueryParamString: action.queryParamString,
         destinationUniqueId:  action.uniqueId
        };
      } else {
      //  console.log(" inside else");
        let lineChartValue = [];
        return {
          ...state,
          flag:0,
          lineChartValue: [],
          isChartDataNull: true,
          respQueryParamString: action.queryParamString,
          destinationUniqueId:  action.uniqueId
        };
      }
    case types.LINE_CHART_FAILURE:
      return {
        ...state,
        flag:1,
        message:'noDataAvlMsg',
      };
    case types.CANDLESTICK_CHART:
      return {
        ...state,
        };
    case types.CANDLESTICK_CHART_SUCCESS:
    if ( action.result.dataObject.length > 0) {
      //let CandleStickChartValue = formatDateTradeDate(action.result.data);
      let CandleStickChartValue = action.result.dataObject;
      return {
        ...state,
        flag:0,
        CandleStickChartValue: CandleStickChartValue,
        isChartDataNull: false,
        respQueryParamString: action.queryParamString,
        destinationUniqueId:  action.uniqueId
      };
    } else {
      let CandleStickChartValue = [];
      return {
        ...state,
        flag:0,
        CandleStickChartValue: [],
        isChartDataNull: true,
        respQueryParamString: action.queryParamString,
        destinationUniqueId:  action.uniqueId
      };
    }
      case types.CANDLESTICK_CHART_FAILURE:
        return {
          ...state,
        };
    case types.HISTORICAL_CHART:
      return {
        ...state,
      };
    case types.HISTORICAL_CHART_SUCCESS:
      if ( action.result.dataObject.length > 0) {
        let historicalData = formatDateTradeDate(action.result.dataObject);
        return {
          ...state,
          flag:0,
          historicalData: historicalData,
          isChartDataNull: false,
          historicalRespQueryParamString: action.queryParamString,
          destinationUniqueId:  Math.floor((Math.random() * 1000000) + 1)
        };
      } else {
        return {
          ...state,
          flag:1,
          message:'noDataAvlMsg',
          historicalData: [],
          isChartDataNull: true,
          historicalRespQueryParamString: action.queryParamString,
          destinationUniqueId:  Math.floor((Math.random() * 1000000) + 1)
        };
      }
    case types.HISTORICAL_CHART_FAILURE:
      return {
        ...state,
      };
    case types.LOCAL_STORAGE_UPDATED:
      return {
        ...state,
        localstorageUpdated: Date.now()
      };
    default:
      return state;
  }
}
